import { createFeatureSelector, createSelector } from '@ngrx/store';

import { isKioskUrl } from '@core/helpers/is-kiosk-url';

import { WebsocketState, websocketFeatureKey } from './websocket.reducer';

export const selectWebsocketFeature = createFeatureSelector<WebsocketState>(websocketFeatureKey);

export const selectWebsocketOnline = createSelector(selectWebsocketFeature, (state: WebsocketState) => state.online);
export const selectWebsocketConnectionInProgress = createSelector(
  selectWebsocketFeature,
  (state: WebsocketState) => state.connectionInProgress
);
export const selectWebsocketError = createSelector(selectWebsocketFeature, (state: WebsocketState) => state.websocketError);
export const selectAuthenticationInProgress = createSelector(
  selectWebsocketFeature,
  (state: WebsocketState) => state.authenticationInProgress
);
export const selectAuthenticated = createSelector(selectWebsocketFeature, (state: WebsocketState) => state.authenticated);
export const selectWebsocketConnectionLost = createSelector(selectWebsocketFeature, (state: WebsocketState) => state.connectionLost);
export const selectConnectionLostOverlayVisible = createSelector(
  selectWebsocketFeature,
  (state: WebsocketState) => state.connectionLostOverlayCanBeShown && !state.connectionLostOverlayDismissed && !isKioskUrl()
);
